export default __webpack_public_path__ + "static/media/rotary_outline.51530536.png";